import { useEffect, useRef } from 'react';

const GoogleMap = () => {
  const mapRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const initMap = () => {
      if (!window.google || !mapRef.current) return;

      // Coordinates for Victoriaville, QC
      const position = { lat: 46.0536, lng: -71.9643 };

      const map = new window.google.maps.Map(mapRef.current, {
        center: position,
        zoom: 13,
      });

      new window.google.maps.Marker({
        map: map,
        position: position,
        title: 'Agro-Réfrigération inc',
      });
    };

    // Load Google Maps script
    const script = document.createElement('script');
    const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '';
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}`;
    script.async = true;
    script.defer = true;
    script.onload = initMap;
    document.head.appendChild(script);

    return () => {
      // Cleanup
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return (
    <div 
      ref={mapRef} 
      className="w-full h-full min-h-[400px] rounded-lg"
      style={{ minHeight: '400px' }}
    />
  );
};

export default GoogleMap;
